var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMieuxGerer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174",
    transform: "translate(-1244 -4226)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 61,
    cy: 61,
    r: 61,
    transform: "translate(1244 4226)",
    fill: "rgba(30,194,138,0.13)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "relationship",
    transform: "translate(1264.952 4246.952)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M34.336,45A11.336,11.336,0,1,0,45.673,56.336,11.35,11.35,0,0,0,34.336,45ZM29.521,63.714a5.021,5.021,0,0,1,9.631,0,8.773,8.773,0,0,1-9.631,0Zm2.3-8.637A2.519,2.519,0,1,1,34.336,57.6,2.522,2.522,0,0,1,31.817,55.077Zm9.325,6.859a7.6,7.6,0,0,0-3.177-3.381,5.038,5.038,0,1,0-7.258,0,7.6,7.6,0,0,0-3.177,3.381,8.818,8.818,0,1,1,13.611,0Z",
    transform: "translate(5.711 11.423)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M40.048,1A11.315,11.315,0,0,0,29.51,16.491a6.21,6.21,0,0,0-2.058-.375,3.784,3.784,0,0,0-3.779,3.779v3.114a6.621,6.621,0,0,1-3.2,5.648,9.109,9.109,0,0,0-3.953,4.929l-.029.088L1,32.382V53.9H40.048a3.765,3.765,0,0,0,3.5-5.183,3.747,3.747,0,0,0,1.814-6.153,3.721,3.721,0,0,0,0-5.038,3.763,3.763,0,0,0-2.8-6.3h-6.3a2.522,2.522,0,0,1-2.519-2.519v-6.3a6.193,6.193,0,0,0-.072-.705A11.334,11.334,0,1,0,40.048,1ZM16.115,51.384H3.519V35.119l12.6,1.049ZM36.269,33.75h6.3a1.26,1.26,0,0,1,0,2.519H33.75v2.519h8.817a1.26,1.26,0,0,1,0,2.519H33.75v2.519h8.817a1.26,1.26,0,0,1,0,2.519H33.75v2.519h6.3a1.26,1.26,0,1,1,0,2.519H18.635V35.213l.278-.831a6.582,6.582,0,0,1,2.859-3.565,9.153,9.153,0,0,0,4.421-7.808V19.9a1.262,1.262,0,0,1,1.26-1.26,3.783,3.783,0,0,1,3.779,3.779v6.3A5.041,5.041,0,0,0,36.269,33.75Zm3.779-12.6a8.817,8.817,0,1,1,8.817-8.817A8.828,8.828,0,0,1,40.048,21.154Z",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M56.336,23A11.336,11.336,0,1,0,67.673,34.336,11.35,11.35,0,0,0,56.336,23Zm0,20.154a8.817,8.817,0,1,1,8.817-8.817A8.828,8.828,0,0,1,56.336,43.154Z",
    transform: "translate(11.423 5.711)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M59.077,29.519v5.038H56.558V27H54.038v7.558H51.519V32.038H49v5.038H61.6V29.519Z",
    transform: "translate(12.461 6.75)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M31,9h2.519v2.519H31Z",
    transform: "translate(7.788 2.077)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M35,9h2.519v2.519H35Z",
    transform: "translate(8.827 2.077)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M27,9h2.519v2.519H27Z",
    transform: "translate(6.75 2.077)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M55.9,21.387l1.683,2.682,1.879-9.4-2.47-.5-.675,3.38A32.6,32.6,0,0,0,43.643,7.528L42.576,9.81A29.944,29.944,0,0,1,55.9,21.387Z",
    transform: "translate(10.793 1.695)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M7.528,23.837,9.812,24.9A29.945,29.945,0,0,1,21.387,11.582L24.068,9.9l-9.4-1.881-.494,2.469,3.38.676A32.59,32.59,0,0,0,7.528,23.837Z",
    transform: "translate(1.695 1.822)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M11.582,46.022,9.9,43.34l-1.879,9.4,2.47.5.675-3.38A32.6,32.6,0,0,0,23.837,59.881L24.905,57.6A29.94,29.94,0,0,1,11.582,46.022Z",
    transform: "translate(1.822 10.992)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M59.881,43.643,57.6,42.576A29.945,29.945,0,0,1,46.021,55.9l-2.68,1.682,9.4,1.881.5-2.47-3.38-.676a32.585,32.585,0,0,0,10.024-12.67Z",
    transform: "translate(10.992 10.793)",
    fill: "#58a596"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMieuxGerer);
export default __webpack_public_path__ + "static/media/mieux_gerer.094fd070111540ae8b8f16adc7ccb411.svg";
export { ForwardRef as ReactComponent };